module.exports = __webpack_public_path__ + "img/10.c80a31a8.jpeg";